import { AllUnits } from '../../../utils/unitUtils'

// returns eg. { nDim: 2, unit: 'm' } or { nDim: 3, unit: undefined }
export const calculateUnitAndDimensions = (el, rawHash) => {
  const unit = el.querySelector('[data-field="measurementUnitValue"]')?.value
  if (rawHash.is_drawing && unit) {
    return {
      nDim: AllUnits[unit].n_dim,
      unit: unit,
    }
  }

  return {
    nDim: [rawHash.width, rawHash.length, rawHash.height_weight].filter(v => v > 0).length,
    unit: undefined,
  }
}

// Get the values of the form fields as an object
// returns eg. { drawing_id: 1, subtract: 1, same_parts: 1, width: 1, length: 1, height_weight: 1, total: 1 }
export const formValues = (el) => {
  const rawHash = Object.fromEntries([...el.querySelectorAll`[name]`].map(i=>[i.name.split`[`.pop().slice(0,-1),i.value]))
  rawHash.is_drawing = rawHash.is_drawing === 'true'
  rawHash.subtract = rawHash.subtract === 'true' ? -1 : 1
  rawHash.same_parts = parseFloat(rawHash.same_parts) || 1
  rawHash.width = parseFloat(rawHash.width) || 0
  rawHash.length = parseFloat(rawHash.length) || 0
  rawHash.height_weight = parseFloat(rawHash.height_weight) || 0
  rawHash.total = parseFloat(rawHash.total) || 0
  const dims = [rawHash.width, rawHash.length, rawHash.height_weight].filter(v => v > 0)
  if (!rawHash.is_drawing && dims.length > 0) {
    rawHash.total = rawHash.same_parts * dims.reduce((acc, val) => acc * val, 1)
  }
  rawHash.dimensions = calculateUnitAndDimensions(el, rawHash)
  return rawHash
}

export const allowFieldEdit = (el) => {
  el.readOnly = false
  el.classList.remove('bg-body-secondary')
}

export const preventFieldEdit = (el, value) => {
  el.readOnly = true
  el.classList.add('bg-body-secondary')
  if (value !== undefined) {
    if (typeof value === 'number') {
      value = Math.round(value * 100) / 100
    }

    el.value = value
  }
}

export const calculateWasteAllowance = (value, wasteAllowance = 0) => {
  if (isNaN(wasteAllowance) || wasteAllowance === 0) {
    return value
  }
  return value + value * wasteAllowance
}

export const calculateQuantityRounding = (value, rounding = 'none') => {
  switch (rounding) {
    case 'up':
      return Math.ceil(value)
    case 'down':
      return Math.floor(value)
    case 'nearest':
      return Math.round(value)
    default:
      return value
  }
}

export const setFieldValidation = (rowEl, isValid) => {
  const totalEl = rowEl.querySelector('[data-field="total"]')
  const measurementEls = rowEl.querySelectorAll('[data-field="width"],[data-field="length"],[data-field="height_weight"]')
  if (isValid) {
    [...measurementEls].forEach(el => el.classList.remove('border-danger'));
  } else {
    [...measurementEls].forEach(el => el.classList.add('border-danger'));
    totalEl.value = ''
  }
}
